import { useState } from "react";
import { useTheme, mono, EqBox, Card, Label, Stat, Btn } from "./appHelpers";

export default function EnergyPage() {
  const C = useTheme();
  const [tab, setTab] = useState("balance");
  const tabs = ["balance", "oberth", "leverage"];

  return (
    <div>
      <div style={{ display: "flex", gap: 6, marginBottom: 18, flexWrap: "wrap" }}>
        {tabs.map(t => <Btn key={t} active={tab === t} onClick={() => setTab(t)}>{t}</Btn>)}
      </div>

      {tab === "balance" && (
        <>
          <Card color="#ef4444">
            <Label color="#ef4444">① Drag — the orbital energy sink</Label>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", gap: 8 }}>
              <Stat label="Drag force (425km)" value="22" unit="μN" color="#ef4444" />
              <Stat label="Orbital velocity" value="7,649" unit="m/s" color={C.text} />
              <Stat label="Drag power" value="168" unit="mW" color="#ef4444" />
              <Stat label="Energy drain / day" value="14,515" unit="J/day" color="#ef4444" />
            </div>
          </Card>
          <Card color="#f59e0b">
            <Label color="#f59e0b">② Propellant energy — how drag is compensated</Label>
            <EqBox lines={[
              "// Stored pressure energy (what's in the tank):",
              "P_pressure = ½ṁvₑ² = 7.5 mW  →  648 J/day  (4.5% of drag)",
              "",
              "// Orbital KE donated by propellant (Oberth effect):",
              "P_oberth   = ṁ × v_orb × vₑ = 165.2 mW  →  14,274 J/day  (95.5%)",
              "",
              "Total energy restored = 648 + 14,274 = 14,915 J/day  ✓",
            ]} />
          </Card>
          <Card color="#0e9cc0">
            <Label color="#0e9cc0">③ EMMS electrical — zero orbital effect</Label>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 8 }}>
              <Stat label="EMMS avg power" value="4" unit="mW" color="#0e9cc0" />
              <Stat label="Energy / day" value="346" unit="J/day" color="#0e9cc0" sub="100% → heat" />
              <Stat label="Orbital force" value="0" unit="N" color="#ef4444" sub="internal force" />
            </div>
          </Card>
        </>
      )}

      {tab === "oberth" && (
        <Card color="#22c55e">
          <Label color="#22c55e">The Oberth Effect — why 4.5% of energy moves 95.5% of work</Label>
          <EqBox color="#6bde9a" lines={[
            "Per gram of cold gas ejected at vₑ=687 m/s:",
            "",
            "  KE before ejection:   ½ × 0.001 × 7649² = 29,254 J",
            "  KE after ejection:    ½ × 0.001 × 6962² = 24,232 J",
            "  KE donated:           29,254 - 24,232   =  5,022 J",
            "",
            "  → Satellite orbital gain:  4,788 J  (Oberth amplification)",
            "  → From stored pressure:      234 J  (½Δm × vₑ²)",
            "",
            "  Leverage per gram: 4788 / 234 = 20.5×",
            "  Stored energy is just the KEY that unlocks orbital KE.",
          ]} />
        </Card>
      )}

      {tab === "leverage" && (
        <Card color="#f59e0b">
          <Label color="#f59e0b">EP-ADCS Energy Leverage — 52×</Label>
          <EqBox lines={[
            "Wasted retro-burn energy (without EP-ADCS):",
            "  E_waste = ṁ_retro × v_orb × vₑ = 18,100 J/day",
            "",
            "EMMS electrical cost:",
            "  E_emms = 4mW × 86400s = 346 J/day",
            "",
            "LEVERAGE = 18,100 / 346 = 52.3×",
            "",
            "Spend 1 joule of electricity → save 52 joules of orbital energy.",
            "Mechanism: precision timing, not thermodynamic magic.",
          ]} />
        </Card>
      )}
    </div>
  );
}
